import SlickSlider from "react-slick";
import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const ContentCard = styled.div(({ theme }) => ({
  padding: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const CardInfo = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "32px",

  [theme.breakpoint.lg()]: {
    height: "auto",
    width: "auto",
    justifyContent: "start",
  },
}));

export const Icon = styled.img(({ theme }) => ({
  width: "45px",
  height: "45px",
  zIndex: "1",
  margin: "auto 0",
}));

export const CardContainer = styled.div(({ theme }) => ({
  color: "white",
  marginLeft: "16px",
  paddingLeft: "16px",
  borderLeft: "1px solid",
  borderLeftColor: "#E3E0E2",
}));

export const CardTitle = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  fontSize: "24px",
  lineHeight: "150%",
  fontWeight: "700",
}));

export const Description = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "150%",
}));
export const ContainerImage = styled.img(({ theme }) => ({
  width: "100%",
  height: "auto",
  objectFit: "scale-down",
}));

export const Slider = styled(SlickSlider)(({ theme, roundedDots }) => ({
  ".slick-dots li button:before": {
    color: roundedDots ? theme.color.highlight["04"] : theme.color.brandPrimary.dark,
    fontSize: "10px",
    opacity: "1",
  },

  ".slick-dots li.slick-active button:before": {
    color: theme.color.neutral["08"],
    opacity: "1",
  },

  ".slick-dots": {
    width: "90%",
  },
}));

export const Paragraph = styled(Text)(({ theme }) => ({
  fontSize: "12px",
  textAlign: "center",
  fontWeight: 500,
  color: theme.color.brandPrimary.light,
  lineHeight: "18px",
  margin: "36px 0px 0px 65px",
}));
